<template>
  <v-container>
    <page-header :title="lang.help" :info="lang.helpInfo" />
    <div v-html="topics" :class="['font-weight-light', 'meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'help',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      topics: null
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      const cache = this.getCachedPage('page', 'help', 'topics')
      cache ? this.done(cache) : this.getHelpPage()
    },
    /**
     * Get the page data from the API
     * @method getHelpPage
     * @return {void}
     */
    getHelpPage () {
      const url = this.$root.routes.find(route => route.url.includes('/help')).url
      this.$http(url)
        .then(response => {
          this.done(response.data.payload.topics)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.topics = this.parseExternalHtml(response)
      this.$nextTick(() => {
        this.emitRouteChange()
        this.setLastBreadcrumbsItemText(lang.help)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/help.vue